export const MIN_USERS_FOR_PREDICTION = 10;

export const AVG_GAMEPLAYS_THRESHOLD = 2;

export const MAX_PREDICTOR_GAMEPLAYS = 99;

export const PREDICTOR_CACHE_EXPIRATION_TIMEOUT = 24 * 60 * 60 * 1000; // 24 hours
